import React from 'react';
import './WizardStep.css';

/**
 * WizardStep Component
 *
 * Reusable container for wizard steps in the Exit Readiness Assessment.
 * Provides consistent layout, navigation, and progress indication.
 */
const WizardStep = ({
  stepNumber,
  totalSteps,
  title,
  description,
  children,
  onNext,
  onPrev,
  onSkip,
  nextLabel = 'Continue',
  prevLabel = 'Back',
  skipLabel = 'Skip',
  showNext = true,
  showPrev = true,
  showSkip = false,
  nextDisabled = false,
  isLoading = false,
  className = ''
}) => {
  const progressPercentage = (stepNumber / totalSteps) * 100;

  return (
    <div className={`wizard-step ${className}`}>
      {/* Progress Bar */}
      <div className="wizard-progress">
        <div className="wizard-progress-bar" style={{ width: `${progressPercentage}%` }} />
        <div className="wizard-progress-text">
          Step {stepNumber} of {totalSteps}
        </div>
      </div>

      {/* Step Content */}
      <div className="wizard-step-content">
        {/* Header */}
        <div className="wizard-step-header">
          <h2 className="wizard-step-title">{title}</h2>
          {description && (
            <p className="wizard-step-description">{description}</p>
          )}
        </div>

        {/* Main Content Area */}
        <div className="wizard-step-body">
          {children}
        </div>

        {/* Navigation Buttons */}
        <div className="wizard-step-footer">
          <div className="wizard-nav-buttons">
            {showPrev && (
              <button
                type="button"
                className="wizard-btn wizard-btn-secondary"
                onClick={onPrev}
                disabled={isLoading}
              >
                {prevLabel}
              </button>
            )}

            {showSkip && (
              <button
                type="button"
                className="wizard-btn wizard-btn-text"
                onClick={onSkip}
                disabled={isLoading}
              >
                {skipLabel}
              </button>
            )}

            <div className="wizard-nav-spacer" />

            {showNext && (
              <button
                type="button"
                className="wizard-btn wizard-btn-primary"
                onClick={onNext}
                disabled={nextDisabled || isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="wizard-btn-spinner" />
                    Loading...
                  </>
                ) : (
                  nextLabel
                )}
              </button>
            )}
          </div>
        </div>

        {/* Copyright Footer */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <div className="assessment-footer">
            © 2025 Dominion Business Advisors LLC. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizardStep;
